const initDynamicConditionalFields = (): void => {
  document.addEventListener('change', (event: Event): void => {
    const targetInput = event.target as HTMLInputElement;
    const wrapper = targetInput.closest('[class*="trigger-"]');
    if (!wrapper) return;
    const triggerClass = Array.from(wrapper.classList).find(cls => cls.startsWith('trigger-'));

    if (triggerClass) {
      const logicName = triggerClass.replace('trigger-', '');
      const form = targetInput.closest('form') as HTMLFormElement | null;
      if (!form) return;
      const targetElements = form.querySelectorAll<HTMLElement>(`.target-${logicName}`);

      targetElements.forEach(el => {
        const isVisible = targetInput.checked;
        el.style.display = isVisible ? 'block' : 'none';

        if (!isVisible) {
          const inputs = el.querySelectorAll('input');
          inputs.forEach(input => {
            input.checked = false;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
      });
    }
  });
};

document.addEventListener('DOMContentLoaded', initDynamicConditionalFields);